module.exports = __webpack_public_path__ + "img/dk.cc6805c7.svg";